import React, { useEffect } from "react";
import "./whychooseus.css";
import { Shield, Zap, Users, Award } from "lucide-react";

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <Shield size={32} />,
      title: "Trusted & Secure",
      desc: "Your data and trust are protected with top-grade security protocols.",
    },
    {
      icon: <Zap size={32} />,
      title: "Fast & Transparent",
      desc: "No hidden steps — instant decisions and clear communication.",
    },
    {
      icon: <Users size={32} />,
      title: "People-Centric",
      desc: "Every solution we build starts with your needs in mind.",
    },
    {
      icon: <Award size={32} />,
      title: "Excellence Recognized",
      desc: "Award-winning service backed by consistent customer satisfaction.",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const shape1 = document.querySelector(".shape1");
      const shape2 = document.querySelector(".shape2");
      const shape3 = document.querySelector(".shape3");

      if (shape1) shape1.style.transform = `translateY(${scrollY * 0.1}px) rotate(-10deg)`;
      if (shape2) shape2.style.transform = `translateY(${scrollY * 0.15}px) rotate(15deg)`;
      if (shape3) shape3.style.transform = `translateY(${scrollY * 0.2}px) rotate(-25deg)`;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="whychooseus-clean">
      <div className="wcu-left new-left">
        <div className="shapes-bg">
          <div className="shape shape1"></div>
          <div className="shape shape2"></div>
          <div className="shape shape3"></div>
        </div>
        <div className="wcu-left-content">
          <h2 className="why-title mb-4">
            Why <span className="highlight">Choose</span> Us
          </h2>
          <p>
            At Fundswalle, we make borrowing easy, quick, and transparent — so
            you can focus on your goals, not the paperwork. Join thousands who
            trust us for smart, stress-free financial solutions.
          </p>
        </div>
      </div>

      <div className="wcu-right">
        {reasons.map((r, i) => (
          <div className="wcu-point" key={i}>
            <div className="icon-circle">{r.icon}</div>
            <div className="text-part">
              <h4>{r.title}</h4>
              <p>{r.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
